import { stringify } from "qs";

const appendSearch = (params: Record<string, string>) => {
  return stringify(params, { addQueryPrefix: true });
};

export function linkToPatientQueueManagement() {
  return "/patient-queue-management";
}

export function linkToPatientQueue(opts: { id?: string } = {}) {
  const search = {
    ...opts,
  };

  return `/queue${appendSearch(search)}`;
}
